<template>
  <div>
    <KeyValue
      :caption="$t('Tenders.Recommendations')"
      class="py-2"
      :data-qa="`${dataQa}-verification`">
      <div>
        <template
          v-if="verificationStatus == 'VERIFIED'">
          <VerificationStatus
            class="mr-1"
            :status="decisionType"/>
        </template>
        {{ verificationStatus == 'VERIFIED' ?
          decisionType == 'RECOMENDED' ?
            $t('Suppliers.RecommendedForCoperation') : $t('Suppliers.NotRecommendedForCoperation')
          : '–' }}
      </div>
    </KeyValue>
    <KeyValue
      :caption="$t(`Suppliers.Comment`)"
      class="py-2"
      :data-qa="`${dataQa}-comment`"
      :value="comment || '–'"/>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import VerificationStatus from 'components/tenders/VerificationStatus.vue'

export default {
  name: 'VerificationResultBlock',
  props: {
    dataQa: String,
    verificationStatus: String,
    decisionType: String,
    comment: String,
  },
  components: {
    KeyValue,
    VerificationStatus,
  }
}
</script>
